import { trackAnalyticsEvent } from '../../services/analytics';
export {
  canTrackAnalytics,
  getConsentState,
  setConsentState,
} from '../../services/analytics';

function normalizeErrorStage(stage) {
  switch (stage) {
    case 'pre_submit':
      return 'pre_submit';
    case 'fetch':
    case 'request':
      return 'fetch';
    case 'http':
    case 'response':
      return 'http';
    case 'parse':
      return 'parse';
    case 'render':
      return 'render';
    case 'timeout':
      return 'timeout';
    case 'aborted':
      return 'aborted';
    default:
      return 'unknown';
  }
}

function normalizeErrorType(errorType, httpStatus) {
  if (errorType === 'empty_query') return 'empty_query';
  if (errorType === 'timeout') return 'timeout';
  if (errorType === 'invalid_json') return 'invalid_json';
  if (errorType === 'render_failure') return 'render_failure';
  if (errorType === 'duplicate_submit_blocked') return 'duplicate_submit_blocked';
  if (errorType === 'aborted') return 'aborted';

  if (errorType === 'network' || errorType === 'network_error') {
    return 'network_error';
  }

  if (Number.isInteger(httpStatus)) {
    if (httpStatus >= 500) return 'http_5xx';
    if (httpStatus >= 400) return 'http_4xx';
  }

  return errorType || 'unknown';
}

export function buildIntegrAIRequestId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return `integrai-${Date.now()}-${Math.random().toString(16).slice(2, 10)}`;
}

export async function trackIntegrAIAsk({
  requestId,
  pagePath,
  langHint,
  queryLength,
  isShortQuery,
}) {
  return trackAnalyticsEvent(
    'integrai_ask',
    {
      request_id: requestId,
      page_path: pagePath,
      lang_hint: langHint,
      query_length: queryLength,
      is_short_query: isShortQuery,
      source: 'integrai_page',
    },
    { requestId }
  );
}

export async function trackIntegrAIAnswer({
  requestId,
  pagePath,
  langHint,
  latencyMs,
  httpStatus,
  answerLengthChars,
  citedSourcesCount,
  routeFamily,
}) {
  return trackAnalyticsEvent(
    'integrai_answer',
    {
      request_id: requestId,
      page_path: pagePath,
      lang_hint: langHint,
      latency_ms: latencyMs,
      http_status: httpStatus,
      answer_length_chars: answerLengthChars,
      cited_sources_count: citedSourcesCount,
      route_family: routeFamily,
    },
    { requestId }
  );
}

export async function trackIntegrAIError({
  requestId,
  pagePath,
  langHint,
  latencyMs,
  httpStatus,
  errorType,
  errorStage,
}) {
  return trackAnalyticsEvent(
    'integrai_error',
    {
      request_id: requestId,
      page_path: pagePath,
      lang_hint: langHint,
      latency_ms: latencyMs,
      http_status: httpStatus,
      error_type: normalizeErrorType(errorType, httpStatus),
      error_stage: normalizeErrorStage(errorStage),
    },
    { requestId }
  );
}
